import {
  AddFundsPage,
  LoadingPage,
} from '@resurs-internal/deposits-app-components';
import { useContext } from 'react';
import { useNavigate, useOutletContext } from 'react-router';

import { type ApplicationHandlerProps } from '@/components';
import { CountryContext } from '@/contexts';
import { getSectionCount, sendGTMApplicationProgress } from '@/helpers';
import { useApplication } from '@/hooks';
import { depositFunds } from '@/services';
import { type MonetaryAmount } from '@/types/consumer-deposit-application-service';

export const FundsAddView = () => {
  const navigate = useNavigate();
  const { applicationId, product } =
    useOutletContext() as ApplicationHandlerProps;
  const { application, isLoading } = useApplication(applicationId);
  const { country } = useContext(CountryContext);

  const navigateBack = () => {
    navigate('../deposit-account');
  };
  const navigateError = () => {
    navigate('/error');
  };
  const handleGTMProgress = (
    applicationId: string,
    productVariant: string,
    stepName: string,
    stepNumber: number,
  ) => {
    sendGTMApplicationProgress({
      applicationId,
      country,
      productVariant,
      stepName,
      stepNumber,
    });
  };

  const handleSubmit = async (
    amount: MonetaryAmount,
    transactionText?: string,
  ) => {
    await depositFunds(
      applicationId,
      `${window.location.origin}/application/${applicationId}/funds`,
      amount,
      transactionText,
    )
      .then((response) => {
        if (response && response._links?.['openbanking-redirect']?.href) {
          window.location.href = response._links['openbanking-redirect'].href;
        }
      })
      .catch((error) => {
        navigateError();
        console.error('Error depositing funds:', error);
      });
  };

  if (isLoading) {
    return <LoadingPage country={country} />;
  }

  return (
    <AddFundsPage
      applicationId={applicationId}
      country={country}
      depositFunds={handleSubmit}
      navigateBack={navigateBack}
      productName={product.name}
      section={getSectionCount(country, application.productType) - 1}
      sendGTMApplicationProgress={handleGTMProgress}
    />
  );
};
